const R = require('ramda')

const makeCategoryUrlFromCategoryName = R.pipe(
  R.toLower,
  R.replace(/,/g, ''),
  R.replace(/\./g, ''),
  R.replace(/ /g, '-')
)

const renderHireProductLink = (slug, category = '') => {
  const categorySlug = makeCategoryUrlFromCategoryName(category)
  return `${categorySlug}/${slug}`
}

module.exports = {
  makeCategoryUrlFromCategoryName: makeCategoryUrlFromCategoryName,
  renderHireProductLink: renderHireProductLink
}



// WEBPACK FOOTER //
// ./src/helpers/RenderHireProductLink.js